<p-drawer [(visible)]="visible" position="right" styleClass="w-full md:w-30rem lg:w-35rem quick-actions-sidebar" [modal]="true" [dismissible]="true" appendTo="body">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <i class="pi pi-bolt text-yellow-500 text-xl"></i>
            <span class="font-bold text-xl text-900">Acciones Rápidas</span>
        </div>
    </ng-template>

    <div class="flex flex-column h-full">
        <!-- SEARCH SECTION -->
        <div class="surface-card p-3 border-round shadow-1 mb-4 border-left-3 border-primary">
            <label class="block font-bold mb-2 text-900">Identificar Artículo <span class="text-red-500">*</span></label>
            <span class="p-input-icon-left w-full">
                <i class="pi pi-search"></i>
                <p-autoComplete 
                    [(ngModel)]="selectedItem"
                    [suggestions]="items()" 
                    (completeMethod)="searchItems($event)" 
                    (onSelect)="onItemSelect($event)"
                    field="name" 
                    placeholder="Buscar por nombre, código o scanear..." 
                    class="w-full"
                    styleClass="w-full"
                    [minLength]="2"
                    [forceSelection]="true"
                    appendTo="body">
                    <ng-template let-item pTemplate="item">
                        <div class="flex align-items-center gap-3">
                            <div class="bg-surface-100 p-2 border-round">
                                <i class="pi pi-box text-primary"></i>
                            </div>
                            <div class="flex flex-column">
                                <span class="font-bold text-sm">{{ item.name }}</span>
                                <small class="text-500 font-mono">{{ item.internal_code }} | Stock: {{ item.stock }}</small>
                            </div>
                        </div>
                    </ng-template>
                </p-autoComplete>
            </span>
            <small class="text-500 mt-2 block">Tip: Puede usar un lector de código de barras directamente aquí.</small>
        </div>

        @if(selectedItem()){
            <!-- ITEM INFO HUB (PREVIEW) -->
            <div class="surface-ground p-3 border-round mb-4 flex align-items-center justify-content-between animate-fadein">
                <div class="flex flex-column gap-1">
                    <span class="text-xs font-bold text-500 uppercase">Artículo Seleccionado</span>
                    <span class="font-bold text-900">{{ selectedItem().name }}</span>
                </div>
                <div class="text-right">
                    <span class="text-xs font-bold text-500 uppercase">Stock Actual</span>
                    <div class="text-xl font-bold" [class.text-red-500]="selectedItem().stock <= selectedItem().min_stock">
                        {{ selectedItem().stock }} {{ selectedItem().form?.name || '' }}
                    </div>
                </div>
            </div>

            <!-- QUICK MOVEMENT FORM -->
            <form [formGroup]="movementForm" (ngSubmit)="saveMovement()" class="flex flex-column gap-4 flex-grow-1">
                <div class="flex flex-column gap-3">
                    <label class="font-bold text-900">Tipo de Movimiento</label>
                    <p-selectButton [options]="movementTypes" formControlName="type" optionLabel="label" optionValue="value" class="quick-type-selector w-full">
                        <ng-template let-item pTemplate="item">
                            <div class="flex align-items-center gap-2 px-3">
                                <i [class]="item.icon"></i>
                                <span>{{ item.label }}</span>
                            </div>
                        </ng-template>
                    </p-selectButton>
                </div>

                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="block font-bold mb-2 text-900">Cantidad</label>
                        <p-inputNumber formControlName="quantity" [min]="1" [showButtons]="true" buttonLayout="horizontal" 
                            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" 
                            class="w-full" styleClass="w-full" inputId="quantity-input">
                        </p-inputNumber>
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="block font-bold mb-2 text-900">Motivo <span class="text-red-500">*</span></label>
                        <p-dropdown [options]="reasons" formControlName="reason" placeholder="Seleccione motivo..." 
                            class="w-full" styleClass="w-full" appendTo="body" [editable]="true"
                            [ngClass]="{'ng-invalid ng-dirty': movementForm.get('reason')?.invalid && movementForm.get('reason')?.touched}">
                        </p-dropdown>
                        @if(movementForm.get('reason')?.invalid && movementForm.get('reason')?.touched){
                            <small class="p-error block mt-1">El motivo es obligatorio.</small>
                        }
                    </div>
                </div>

                <p-divider></p-divider>

                <div class="flex flex-column gap-3 mt-auto">
                    <p-button label="Confirmar Movimiento" icon="pi pi-check" severity="success" 
                        type="submit" [loading]="isSaving()" [disabled]="movementForm.invalid" 
                        styleClass="w-full py-3 font-bold shadow-2" [rounded]="true">
                    </p-button>
                    <p-button label="Limpiar Selección" icon="pi pi-refresh" [text]="true" severity="secondary" 
                        (onClick)="resetForm()" styleClass="w-full" [rounded]="true">
                    </p-button>
                </div>
            </form>
        } @else {
            <div class="flex-grow-1 flex flex-column align-items-center justify-content-center text-500 opacity-60">
                <i class="pi pi-search-plus text-6xl mb-3"></i>
                <p class="text-center font-medium">Busque un artículo para comenzar<br>un movimiento rápido.</p>
            </div>
        }
    </div>
</p-drawer>
